export default __webpack_public_path__ + "static/media/cases1.64dcfe4d.jpg";